import { BarChart3, BookOpen, CircleHelp } from 'lucide-react'
import { NavLink } from 'react-router-dom'

import { cn } from '@/lib/cn'

const navigation = [
  { to: '/', label: 'Play', icon: BookOpen },
  { to: '/stats', label: 'Stats', icon: BarChart3 },
  { to: '/about', label: 'How to play', icon: CircleHelp },
]

export function SiteHeader() {
  return (
    <header className="bg-background/90 sticky top-0 z-40 border-b backdrop-blur">
      <div className="mx-auto flex h-16 max-w-[1600px] items-center justify-between px-4 sm:px-6 lg:px-8">
        <NavLink to="/" className="text-2xl font-black tracking-tight" aria-label="Jumpdle home">
          <span className="text-primary">Jump</span>dle
        </NavLink>
        <nav aria-label="Main navigation" className="flex items-center gap-1">
          {navigation.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }) =>
                cn(
                  'hover:bg-accent inline-flex h-10 items-center gap-2 rounded-md px-3 text-sm font-semibold transition-colors',
                  isActive && 'bg-accent text-accent-foreground',
                )
              }
            >
              <Icon aria-hidden="true" className="size-4" />
              <span className="hidden sm:inline">{label}</span>
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  )
}
